import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';

// TeamMember component for each team member
const TeamMember = ({ image, name, designation, phone, socialLinks }) => {
  return (
    <div className="team-block-two">
      <div className="inner-box">
        <figure className="image">
          <img src={image} alt={name} />
        </figure>
        <div className="content">
          <div className="designation">{designation}</div>
          <h4 className="name">
            <a href="page-team-details.html">{name}</a>
          </h4>
          <div className="info-box">
            <a href={`tel:${phone}`} className="info-btn">
              <span className="icon">
                <i className="fa-sharp fa-light fa-phone-volume"></i>
              </span>
              <span className="text">{phone}</span>
            </a>
            <ul className="social-icon-two">
              {socialLinks.map((link, index) => (
                <li key={index}>
                  <a href={link.url}>
                    <i className={link.icon}></i>
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

// Main Team Section component
const TeamSection = () => {
  const teamMembers = [
    {
      image: 'images/resource/team2-1.jpg',
      name: 'Tricia Gibney',
      designation: 'President of Sales',
      phone: '(239) 555-0108',
      socialLinks: [
        { url: '#', icon: 'fab fa-facebook-f' },
        { url: '#', icon: 'fab fa-pinterest-p' }
      ]
    },
    {
      image: 'images/resource/team2-2.jpg',
      name: 'Tricia Gibney',
      designation: 'President of Sales',
      phone: '(239) 555-0108',
      socialLinks: [
        { url: '#', icon: 'fab fa-facebook' },
        { url: '#', icon: 'fab fa-linkedin' }
      ]
    },
    {
      image: 'images/resource/team2-3.jpg',
      name: 'Tricia Gibney',
      designation: 'President of Sales',
      phone: '(239) 555-0108',
      socialLinks: [
        { url: '#', icon: 'fab fa-facebook' },
        { url: '#', icon: 'fab fa-linkedin' }
      ]
    },
    {
      image: 'images/resource/team2-4.jpg',
      name: 'Arthur A. Vandusen',
      designation: 'CEO & Founder',
      phone: '(239) 555-0108',
      socialLinks: [
        { url: '#', icon: 'fab fa-facebook' },
        { url: '#', icon: 'fab fa-linkedin' }
      ]
    },
    {
      image: 'images/resource/team2-5.jpg',
      name: 'Tricia Gibney',
      designation: 'President of Sales',
      phone: '(239) 555-0108',
      socialLinks: [
        { url: '#', icon: 'fab fa-facebook-f' },
        { url: '#', icon: 'fab fa-pinterest-p' }
      ]
    }
  ];

  return (
    <section className="team-section-two pt-0">
      <div className="auto-container">
        <div className="outer-box">
          <div className="sec-title">
            <span className="sub-title">Our Expert Drivers</span>
            <h2 className="letters-slide-up text-split">Meet Our Drivers</h2>
          </div>
          <div className="carousel-outer">
            {/* Swiper */}
            <Swiper
              spaceBetween={10}
              loop={true}
              navigation
              breakpoints={{
                320: { // mobile view
                  slidesPerView: 1, // 1 slide visible in mobile
                },
                768: { // tablet view
                  slidesPerView: 2, // 2 slides visible in tablet view
                },
                1024: { // desktop view
                  slidesPerView: 3, // 3 slides visible in desktop
                },
              }}
            >
              {teamMembers.map((member, index) => (
                <SwiperSlide key={index}>
                  <TeamMember {...member} />
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
          {/* If you need navigation buttons */}
          <div className="swiper-button-prev">
            <i className="icon fa fa-angles-left"></i>
          </div>
          <div className="swiper-button-next">
            <i className="icon fa fa-angles-right"></i>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TeamSection;
